// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3simu","left":"styles_left__YOivm"};